import normalizeSearchText from '../utils/search-text';

export default function initApplicationForm() {
  const form = document.querySelector('[data-application-form]');

  if (!form) {
    return;
  }

  const config = window.vizaAzApplication || {};
  const destinationField = form.querySelector('[data-destination-select]');
  const destinationInput = form.querySelector('[data-application-destination-search]');
  const destinationResults = form.querySelector('[data-application-destination-results]');
  const destinationFlag = form.querySelector('[data-application-destination-flag]');
  const searchConfig = window.vizaAzDestinationSearch || {};
  // Süzgəc yerli olduğuna görə tək hərf də dərhal cavab verir.
  const MIN_QUERY_LENGTH = 1;
  const visaTypeField = form.querySelector('[data-visa-type-select]');
  const visaTypeOptions = form.querySelector('[data-visa-type-options]');
  const visaTypeHelp = form.querySelector('[data-visa-type-help]');
  const steps = Array.from(form.querySelectorAll('[data-application-step]'));
  const progress = document.querySelector('.application-progress');
  const progressSteps = Array.from(document.querySelectorAll('[data-progress-step]'));
  const stepStatus = document.querySelector('[data-step-status]');
  const summaryDestination = form.querySelector('[data-summary-destination]');
  const summaryDestinationFlag = form.querySelector('[data-summary-destination-flag]');
  const summaryVisa = form.querySelector('[data-summary-visa]');
  const summaryVisaRow = form.querySelector('[data-summary-visa-row]');
  const summaryVisaLabel = form.querySelector('[data-summary-visa-label]');
  const visaFreeNotice = form.querySelector('[data-visa-free-notice]');
  const visaFreeTitle = form.querySelector('[data-visa-free-title]');
  const visaFreeText = form.querySelector('[data-visa-free-text]');
  const notice = document.querySelector('[data-application-notice]');
  const noticeIcon = notice?.querySelector('[data-application-notice-icon]');
  const noticeMessage = notice?.querySelector('[data-application-notice-message]');
  const submit = form.querySelector('[type="submit"]');
  const submitText = form.querySelector('[data-application-submit-text]');
  const defaultSubmitText = submitText ? submitText.textContent : '';
  const requestedVisaType = form.dataset.requestedVisaType || '';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let currentStep = 1;
  let currentVisaTypes = [];
  let searchTimer;
  let searchController;
  let activeResultIndex = -1;
  let searchResults = [];
  let defaultSearchResults = Array.isArray(searchConfig.catalogue) && searchConfig.catalogue.length
    ? searchConfig.catalogue
    : null;
  let pendingSearchQuery = null;
  let shouldShowDestinationResults = false;

  const closeDestinationResults = () => {
    if (!destinationResults || !destinationInput) {
      return;
    }

    shouldShowDestinationResults = false;
    searchController?.abort();
    searchController = null;
    pendingSearchQuery = null;
    destinationResults.hidden = true;
    destinationResults.replaceChildren();
    destinationInput.setAttribute('aria-expanded', 'false');
    destinationInput.removeAttribute('aria-activedescendant');
    activeResultIndex = -1;
    searchResults = [];
  };

  const clearSelectedDestination = () => {
    if (!destinationField) {
      return;
    }

    destinationField.value = '';
    destinationField.dataset.destinationTitle = '';
    destinationField.dataset.destinationFlagUrl = '';
    if (destinationFlag) {
      destinationFlag.removeAttribute('src');
      destinationFlag.hidden = true;
    }
    destinationField.dataset.visaTypes = '[]';
    setVisaTypeOptions();
    updateSummary();
  };

  const selectDestination = (destination) => {
    if (!destinationField || !destinationInput) {
      return;
    }

    destinationField.value = String(destination.id || '');
    destinationField.dataset.destinationTitle = destination.title || '';
    // Kataloq bayrağı mətn kimi verir; köhnə cavablarda obyekt ola bilər.
    const selectedFlagUrl = 'string' === typeof destination.flag ? destination.flag : destination.flag?.url || '';

    destinationField.dataset.destinationFlagUrl = selectedFlagUrl;
    destinationField.dataset.visaTypes = JSON.stringify(
      Array.isArray(destination.visa_types) ? destination.visa_types : [],
    );
    destinationInput.value = destination.title || '';
    if (destinationFlag) {
      if (selectedFlagUrl) {
        destinationFlag.src = selectedFlagUrl;
      } else {
        destinationFlag.removeAttribute('src');
      }
      destinationFlag.hidden = !selectedFlagUrl;
    }
    destinationInput.setCustomValidity('');
    setVisaTypeOptions();
    updateSummary();
    closeDestinationResults();
  };

  const setActiveDestinationResult = (nextIndex) => {
    if (!searchResults.length || !destinationInput) {
      return;
    }

    activeResultIndex = (nextIndex + searchResults.length) % searchResults.length;
    searchResults.forEach((result, index) => {
      const isActive = index === activeResultIndex;
      result.classList.toggle('is-active', isActive);
      result.setAttribute('aria-selected', String(isActive));
    });
    destinationInput.setAttribute('aria-activedescendant', searchResults[activeResultIndex].id);
    searchResults[activeResultIndex].scrollIntoView({ block: 'nearest' });
  };

  const showDestinationMessage = (message, isError = false) => {
    if (!destinationResults || !destinationInput) {
      return;
    }

    const status = document.createElement('p');
    status.className = `application-destination-search__status${isError ? ' is-error' : ''}`;
    status.setAttribute('role', 'status');
    status.textContent = message;
    destinationResults.replaceChildren(status);
    destinationResults.hidden = false;
    destinationInput.setAttribute('aria-expanded', 'true');
    activeResultIndex = -1;
    searchResults = [];
  };

  const showDestinationResults = (items) => {
    if (!destinationResults || !destinationInput) {
      return;
    }

    if (!items.length) {
      showDestinationMessage(searchConfig.noResultsText || 'Uyğun ölkə tapılmadı.');
      return;
    }

    const fragment = document.createDocumentFragment();
    items.forEach((item, index) => {
      const result = document.createElement('button');
      result.id = `${destinationResults.id}-option-${index}`;
      result.className = 'application-destination-search__result';
      result.type = 'button';
      result.setAttribute('role', 'option');
      result.setAttribute('aria-selected', 'false');
      const itemFlagUrl = 'string' === typeof item.flag ? item.flag : item.flag?.url;

      if (itemFlagUrl) {
        const flag = document.createElement('img');
        flag.className = 'application-destination-search__result-flag';
        flag.src = itemFlagUrl;
        flag.alt = '';
        flag.width = 28;
        flag.height = 19;
        flag.loading = 'lazy';
        result.appendChild(flag);
      }
      const title = document.createElement('span');
      title.textContent = item.title;
      result.appendChild(title);
      result.destinationData = item;
      result.addEventListener('click', () => selectDestination(item));
      fragment.appendChild(result);
    });

    destinationResults.replaceChildren(fragment);
    destinationResults.hidden = false;
    destinationInput.setAttribute('aria-expanded', 'true');
    activeResultIndex = -1;
    searchResults = Array.from(destinationResults.querySelectorAll('.application-destination-search__result'));
  };

  // Azərbaycan əlifbasında İ/i və I/ı ingilis qaydası ilə səhv çevrilir.
  const normalizeTitle = normalizeSearchText;

  const filterCatalogue = (query) => {
    const needle = normalizeTitle(query);
    const starts = [];
    const contains = [];

    (defaultSearchResults || []).forEach((item) => {
      const title = normalizeTitle(item.title);

      if (title.startsWith(needle)) {
        starts.push(item);
      } else if (title.includes(needle)) {
        contains.push(item);
      }
    });

    return starts.concat(contains).slice(0, 8);
  };

  const searchDestinations = async (query) => {
    if (pendingSearchQuery === query) {
      return;
    }

    searchController?.abort();
    searchController = new AbortController();
    const currentController = searchController;
    pendingSearchQuery = query;
    const body = new URLSearchParams({
      action: 'viza_az_search_destinations',
      nonce: searchConfig.nonce,
      query,
    });

    try {
      const response = await window.fetch(searchConfig.ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        body: body.toString(),
        signal: currentController.signal,
      });
      const payload = await response.json();

      if (!response.ok || !payload.success || !Array.isArray(payload.data?.results)) {
        throw new Error('Invalid destination search response');
      }

      if (query === '') {
        defaultSearchResults = payload.data.results;
      }

      if (
        shouldShowDestinationResults
        && destinationInput
        && destinationInput.value.trim() === query
      ) {
        showDestinationResults(payload.data.results);
      }
    } catch (error) {
      if (
        error.name !== 'AbortError'
        && shouldShowDestinationResults
        && destinationInput?.value.trim() === query
      ) {
        showDestinationMessage(searchConfig.errorText || 'Axtarış mümkün olmadı.', true);
      }
    } finally {
      if (searchController === currentController) {
        searchController = null;
        pendingSearchQuery = null;
      }
    }
  };

  const showDefaultDestinationResults = () => {
    if (!destinationInput || destinationInput.value.trim() !== '') {
      return;
    }

    shouldShowDestinationResults = true;

    if (defaultSearchResults !== null) {
      showDestinationResults(defaultSearchResults);
      return;
    }

    searchDestinations('');
  };

  const readSelectedVisaTypes = () => {
    if (!destinationField || !destinationField.dataset.visaTypes) {
      return [];
    }

    try {
      const visaTypes = JSON.parse(destinationField.dataset.visaTypes);
      return Array.isArray(visaTypes) ? visaTypes : [];
    } catch (error) {
      return [];
    }
  };

  const selectVisaType = (visaType, focusCard = false) => {
    if (!visaTypeField || !visaTypeOptions) {
      return;
    }

    visaTypeField.value = visaType;
    const cards = Array.from(visaTypeOptions.querySelectorAll('[data-visa-type-card]'));

    cards.forEach((card) => {
      const isSelected = card.dataset.visaTypeValue === visaType;
      card.classList.toggle('is-selected', isSelected);
      card.setAttribute('aria-checked', String(isSelected));
      card.tabIndex = isSelected ? 0 : -1;

      if (isSelected && focusCard) {
        card.focus();
      }
    });

    visaTypeOptions.classList.remove('has-error');
    visaTypeOptions.removeAttribute('aria-invalid');
    if (visaTypeHelp) {
      visaTypeHelp.hidden = true;
      visaTypeHelp.textContent = '';
    }
    updateSummary();
  };

  const setVisaTypeOptions = (preferredVisaType = '') => {
    if (!destinationField || !visaTypeField || !visaTypeOptions) {
      return [];
    }

    const visaTypes = readSelectedVisaTypes();
    visaTypeField.value = '';
    visaTypeOptions.replaceChildren();
    visaTypeOptions.classList.remove('has-error');
    visaTypeOptions.removeAttribute('aria-invalid');

    if (!destinationField.value) {
      if (visaTypeHelp) {
        visaTypeHelp.hidden = true;
        visaTypeHelp.textContent = '';
      }
    } else if (!visaTypes.length) {
      if (visaTypeHelp) {
        visaTypeHelp.hidden = false;
        visaTypeHelp.textContent = config.noVisaTypesText || 'Bu ölkə üçün ayrıca viza növü qeyd edilməyib';
      }
    } else {
      if (visaTypeHelp) {
        visaTypeHelp.hidden = true;
        visaTypeHelp.textContent = '';
      }
    }

    visaTypes.forEach((visaType, index) => {
      const card = document.createElement('button');
      const title = document.createElement('span');
      const action = document.createElement('span');
      const arrow = document.createElement('span');
      const indicator = document.createElement('span');

      card.type = 'button';
      card.className = 'application-visa-type';
      card.dataset.visaTypeCard = '';
      card.dataset.visaTypeValue = visaType;
      card.setAttribute('role', 'radio');
      card.setAttribute('aria-checked', 'false');
      card.tabIndex = index === 0 ? 0 : -1;

      title.className = 'application-visa-type__title';
      title.textContent = visaType;
      action.className = 'application-visa-type__action';
      action.textContent = config.chooseVisaTypeActionText || 'Viza növünü seç';
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '→';
      action.appendChild(arrow);
      indicator.className = 'application-visa-type__indicator';
      indicator.setAttribute('aria-hidden', 'true');
      indicator.textContent = '✓';

      card.append(title, action, indicator);
      card.addEventListener('click', () => selectVisaType(visaType));
      card.addEventListener('keydown', (event) => {
        const cards = Array.from(visaTypeOptions.querySelectorAll('[data-visa-type-card]'));
        const currentIndex = cards.indexOf(card);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = (currentIndex + 1) % cards.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = (currentIndex - 1 + cards.length) % cards.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = cards.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        selectVisaType(cards[nextIndex].dataset.visaTypeValue, true);
      });
      visaTypeOptions.appendChild(card);
    });

    if (visaTypes.length) {
      appendTravelPlanningCard();
    }

    if (preferredVisaType && visaTypes.includes(preferredVisaType)) {
      selectVisaType(preferredVisaType);
    }

    currentVisaTypes = visaTypes;
    return visaTypes;
  };

  const updateSummary = () => {
    if (summaryDestination) {
      summaryDestination.textContent = destinationField?.value
        ? destinationField.dataset.destinationTitle || ''
        : '';
    }

    if (summaryDestinationFlag) {
      const flagUrl = destinationField?.value ? destinationField.dataset.destinationFlagUrl || '' : '';
      if (flagUrl) {
        summaryDestinationFlag.src = flagUrl;
      } else {
        summaryDestinationFlag.removeAttribute('src');
      }
      summaryDestinationFlag.hidden = !flagUrl;
    }

    if (summaryVisa) {
      summaryVisa.textContent = visaTypeField?.value || '';
    }

    if (summaryVisaRow) {
      const value = visaTypeField?.value || '';
      summaryVisaRow.hidden = !value;

      if (summaryVisaLabel) {
        summaryVisaLabel.textContent = value === (config.travelPlanningValue || '')
          ? config.requestTypeLabel || 'Müraciət növü'
          : config.visaTypeLabel || 'Viza növü';
      }
    }
  };

  const updateProgress = (stepNumber) => {
    if (progress) {
      progress.style.setProperty('--application-progress-value', String((stepNumber - 1) / 2));
    }

    progressSteps.forEach((item) => {
      const itemStep = Number(item.dataset.progressStep);
      const isCurrent = itemStep === stepNumber;
      item.classList.toggle('is-current', isCurrent);
      item.classList.toggle('is-complete', itemStep < stepNumber);

      if (isCurrent) {
        item.setAttribute('aria-current', 'step');
      } else {
        item.removeAttribute('aria-current');
      }
    });
  };

  const showStep = (stepNumber, options = {}) => {
    const { focus = true, animate = true } = options;
    const target = steps.find((step) => Number(step.dataset.applicationStep) === stepNumber);

    if (!target) {
      return;
    }

    steps.forEach((step) => {
      step.hidden = step !== target;
      step.classList.remove('is-step-entering');
    });

    currentStep = stepNumber;
    updateProgress(stepNumber);
    updateSummary();

    if (animate && !reduceMotion) {
      target.classList.add('is-step-entering');
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => target.classList.remove('is-step-entering'));
      });
    }

    const heading = target.querySelector('h3');
    if (stepStatus && heading) {
      stepStatus.textContent = heading.textContent;
    }
    if (focus && heading) {
      heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });
    }
  };

  /** Ölkənin viza növləri ilə yanaşı təklif olunan "vizam var" variantı. */
  const appendTravelPlanningCard = () => {
    if (!visaTypeOptions) {
      return;
    }

    const value = config.travelPlanningValue || 'Səyahət planlaması';
    const group = document.createElement('div');
    const heading = document.createElement('p');
    const card = document.createElement('button');
    const title = document.createElement('span');
    const action = document.createElement('span');
    const indicator = document.createElement('span');

    group.className = 'application-visa-types__alt';
    heading.className = 'application-visa-types__alt-title';
    heading.textContent = config.travelPlanningGroupTitle || 'Vizanız artıq var?';

    card.type = 'button';
    card.className = 'application-visa-type application-visa-type--alt';
    card.dataset.visaTypeCard = '';
    card.dataset.visaTypeValue = value;
    card.setAttribute('role', 'radio');
    card.setAttribute('aria-checked', 'false');
    card.tabIndex = -1;

    title.className = 'application-visa-type__title';
    title.textContent = config.travelPlanningTitle || 'Vizam var, səyahət planlamaq istəyirəm';

    action.className = 'application-visa-type__action';
    action.textContent = config.travelPlanningText || '';

    indicator.className = 'application-visa-type__indicator';
    indicator.setAttribute('aria-hidden', 'true');

    // Element sırası mövcud kartlarla eyni olmalıdır — indikator sonuncudur.
    card.append(title, action, indicator);
    card.addEventListener('click', () => selectVisaType(value));
    group.append(heading, card);
    visaTypeOptions.appendChild(group);
  };

  /** Vizasız ölkələrdə izah blokunu göstərir və müraciət növünü təyin edir. */
  const applyVisaFreeState = (isVisaFree) => {
    if (visaFreeNotice) {
      visaFreeNotice.hidden = !isVisaFree;
    }

    if (!isVisaFree) {
      return;
    }

    const name = destinationField?.dataset.destinationTitle || '';

    if (visaFreeTitle) {
      visaFreeTitle.textContent = config.visaFreeNoticeTitle || '';
    }

    if (visaFreeText) {
      visaFreeText.textContent = (config.visaFreeNoticeText || '%s').replace('%s', name);
    }

    // Müraciət boş viza növü ilə getməsin — ofis nə istənildiyini görməlidir.
    if (visaTypeField) {
      visaTypeField.value = config.travelPlanningValue || 'Səyahət planlaması';
    }
  };

  const goForwardFromCountry = () => {
    if (!destinationField?.value || !destinationInput) {
      destinationInput?.setCustomValidity(config.selectDestinationText || 'Axtarış nəticələrindən ölkəni seçin.');
      destinationInput?.reportValidity();
      return;
    }

    const visaTypes = setVisaTypeOptions();
    const isVisaFree = !visaTypes.length;

    applyVisaFreeState(isVisaFree);

    if (isVisaFree) {
      updateSummary();
    }

    showStep(isVisaFree ? 3 : 2);
  };

  const goForwardFromVisa = () => {
    if (!visaTypeField?.value || !visaTypeOptions) {
      visaTypeOptions?.classList.add('has-error');
      visaTypeOptions?.setAttribute('aria-invalid', 'true');
      if (visaTypeHelp) {
        visaTypeHelp.textContent = config.selectVisaTypeText || 'Davam etmək üçün viza növünü seçin.';
        visaTypeHelp.hidden = false;
      }
      visaTypeOptions?.querySelector('[data-visa-type-card]')?.focus();
      return;
    }

    showStep(3);
  };

  form.classList.add('is-builder-ready');

  if (destinationInput && destinationResults && searchConfig.ajaxUrl && searchConfig.nonce) {
    destinationInput.addEventListener('focus', showDefaultDestinationResults);
    destinationInput.addEventListener('click', showDefaultDestinationResults);

    destinationInput.addEventListener('input', () => {
      const query = destinationInput.value.trim();
      window.clearTimeout(searchTimer);
      clearSelectedDestination();
      destinationInput.setCustomValidity(query ? (config.selectDestinationText || 'Axtarış nəticələrindən ölkəni seçin.') : '');

      shouldShowDestinationResults = true;

      if (query === '') {
        showDefaultDestinationResults();
        return;
      }

      if (query.length < MIN_QUERY_LENGTH) {
        searchController?.abort();
        closeDestinationResults();
        return;
      }

      // Kataloq hazırdırsa nəticə dərhal göstərilir.
      if (defaultSearchResults !== null) {
        showDestinationResults(filterCatalogue(query));
        return;
      }

      searchTimer = window.setTimeout(() => searchDestinations(query), 280);
    });

    destinationInput.addEventListener('keydown', (event) => {
      if (destinationResults.hidden) {
        return;
      }

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        setActiveDestinationResult(activeResultIndex + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        setActiveDestinationResult(activeResultIndex - 1);
      } else if (event.key === 'Enter' && activeResultIndex >= 0) {
        event.preventDefault();
        selectDestination(searchResults[activeResultIndex].destinationData);
      } else if (event.key === 'Escape') {
        closeDestinationResults();
      }
    });

    document.addEventListener('click', (event) => {
      if (!destinationResults.parentElement?.contains(event.target)) {
        closeDestinationResults();
      }
    });
  }

  form.querySelector('[data-step-next="country"]')?.addEventListener('click', goForwardFromCountry);
  form.querySelector('[data-step-next="visa"]')?.addEventListener('click', goForwardFromVisa);
  form.querySelector('[data-step-back="1"]')?.addEventListener('click', () => showStep(1));
  form.querySelector('[data-step-back="details"]')?.addEventListener('click', () => {
    showStep(currentVisaTypes.length ? 2 : 1);
  });

  const initialVisaTypes = setVisaTypeOptions(requestedVisaType);
  let initialStep = 1;

  if (destinationField && destinationField.value) {
    initialStep = initialVisaTypes.length ? 2 : 3;

    // Ölkə linkdən gəldiyinə görə goForwardFromCountry() işə düşmür;
    // vizasız izahı və müraciət növü burada qurulur.
    applyVisaFreeState(!initialVisaTypes.length);
    updateSummary();

    if (requestedVisaType && visaTypeField && visaTypeField.value === requestedVisaType) {
      initialStep = 3;
    }
  }

  showStep(initialStep, { focus: false, animate: false });

  const showNotice = (message, success) => {
    if (!notice) {
      return;
    }

    if (noticeMessage) {
      noticeMessage.textContent = message;
    } else {
      notice.textContent = message;
    }
    if (noticeIcon) {
      noticeIcon.hidden = !success;
    }
    notice.hidden = false;
    notice.classList.toggle('application-form__notice--success', success);
    notice.classList.toggle('application-form__notice--error', !success);
    notice.setAttribute('role', success ? 'status' : 'alert');
    notice.scrollIntoView({ behavior: 'auto', block: 'nearest' });
  };

  const resetTurnstile = () => {
    if (window.turnstile && typeof window.turnstile.reset === 'function') {
      window.turnstile.reset();
    }
  };

  if (!config.ajaxUrl || !window.fetch) {
    return;
  }

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    if (currentStep !== 3) {
      return;
    }

    if ((submit && submit.disabled) || !form.reportValidity()) {
      return;
    }

    if (notice) {
      notice.hidden = true;
    }

    form.setAttribute('aria-busy', 'true');
    if (submit) {
      submit.disabled = true;
    }
    if (submitText) {
      submitText.textContent = config.sendingText || 'Göndərilir...';
    }

    try {
      const response = await window.fetch(config.ajaxUrl, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });
      const result = await response.json();
      const message = result && result.data && result.data.message
        ? result.data.message
        : config.errorText;

      if (!response.ok || !result.success) {
        throw new Error(message);
      }

      showNotice(message, true);
      form.reset();
      form.hidden = true;
      if (progress) {
        progress.hidden = true;
      }
      resetTurnstile();
    } catch (error) {
      showNotice(error.message || config.errorText, false);
      resetTurnstile();
    } finally {
      form.removeAttribute('aria-busy');
      if (submit) {
        submit.disabled = false;
      }
      if (submitText) {
        submitText.textContent = defaultSubmitText;
      }
    }
  });
}
